import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addtoCard } from "../redux/actions/productAction";
import { ToastContainer, toast } from "react-toastify";
import "../styles/LeDetail.css";

const LeDetail = () => {
  const dispatch = useDispatch();
  const produit = useSelector((state) => state.ProduitDetail.produit);
  const { category, description, image, price, rating, title } = produit;

  const AddToCard = (produit) => {
    toast.success("Le Produit est bien ajouter dans le panier!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch(addtoCard(produit));
  };

  return (
    <div key={produit.id}>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div id="container">
        <div class="product-details">
          <h4>{title}</h4>
          <br />
          <span class="hint-star star">
            <span className="rate">{rating.rate}</span>
            <i class="fa fa-star fa-2x" aria-hidden="true"></i>
          </span>
          <p class="information"> {category}</p>
          <div class="control" onClick={() => AddToCard(produit)}>
            <button class="btn">
              <span class="price">$2{price}</span>
              <span class="shopping-cart">
                <i class="fa fa-shopping-cart" aria-hidden="true"></i>
              </span>
              <span class="buy">Get now</span>
            </button>
          </div>
        </div>
        <div class="product-image">
          <img src={image} alt="" />
          <div class="info">
            <p>{description}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeDetail;
